import type { ClusteringConfig } from "../clustering";

export const SITES_CLUSTERING_CONFIG: ClusteringConfig = {
  intersectField: "bounding_box",
  clusterField: "centre",
  minPrecision: 0,
  minReturnResultsPrecision: 12,
  forceExplodePrecision: 20,
  clusterExplosionThreshold: 100,
};
